
export { default as MapFactory } from './map.factory';